
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donation/[donationUrl]",
      function () {
        return require("private-next-pages/donation/[donationUrl]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donation/[donationUrl]"])
      });
    }
  